import vue from 'vue'
import moment from 'moment'
import {
  getPersonInfo,
  getMyQuotation,
  getMyCollect,
  getMyDraft,
  editDraftQuotation,
  editRowQuotation,
  deleteQuotation,
  collectQuotation,
  cancelCollectQuotation,
  getUserDetails,
  updateUser,
  unbindWx, getBoundCode, getBoundStatus
} from "@/services/dynamic/dynamicMy";
import {compareMonth} from "../../../utils/tool";

const state = {
  childMenu: vue.ls.get('childMenu'),
  myQuotation: {},//我的动态
  personInfo: {},//个人信息
  myCollect: {},//我的收藏
  myDraft: {},//我的草稿
  filterDTInit: {},//动态的
  filterCGInit: {},//草稿的
  filterSCInit: {},//收藏的
  userData: {},//用户信息
  editVisible: false,
  wxVisible: false,
  wx_code: '',//微信登录二维码内容
  codeState: '',
};

const getters = {
  childMenu: () => state.childMenu ? state.childMenu : vue.ls.get('childMenu'),
  myQuotation: () => state.myQuotation,
  personInfo: () => state.personInfo,
  myCollect: () => state.myCollect,
  myDraft: () => state.myDraft,
  filterDTInit: () => state.filterDTInit,
  filterCGInit: () => state.filterCGInit,
  filterSCInit: () => state.filterSCInit,
  userData: () => state.userData,
  editVisible: () => state.editVisible,
  wxVisible: () => state.wxVisible,
  wx_code: () => state.wx_code,
  codeState: () => state.codeState,
};

const actions = {
  //todo 财粮说我的动态
  getMyQuotation({commit, dispatch}, objc) {
    getMyQuotation({...state.filterDTInit}).then((res) => {
      if (res.code === 0) {
        let month = [];
        //11月份区分
        let arr = JSON.parse(JSON.stringify(res.data));
        arr.map((i) => {
          let {months} = moment(i.createTime).toObject();
          compareMonth(month, months + 1);
        });
        //处理成有月份
        month.map((item) => {
          item.list = arr.filter((i) => {
            let {months} = moment(i.createTime).toObject();
            return months + 1 == item.month
          });
        })
        commit('updateState', {state: 'myQuotation', update: month});
      }
    })
  },
  //todo 财粮说我的收藏
  getMyCollect({commit, dispatch}, objc) {
    getMyCollect({...state.filterSCInit}).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'myCollect', update: res.data});
      }
    })
  },
  //todo 财粮说我的草稿
  getMyDraft({commit, dispatch}, objc) {
    getMyDraft({...state.filterCGInit}).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'myDraft', update: res.data});
      }
    })
  },
  //todo 获取我的个人信息
  getPersonInfo({commit, dispatch}, objc) {
    getPersonInfo(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'personInfo', update: res.data});
      }
    })
  },
  //编辑草稿
  editDraftQuotation({commit, dispatch}, objc) {
    let obj = JSON.parse(JSON.stringify(objc.params))
    //处理时间
    if (obj.time && obj.time.length > 0) {
      obj.beginDate = obj.time[0] + ':00';
      obj.endDate = obj.time[1] + ':00';
      delete obj.time;
    }
    let arr = [];
    if (obj && obj.labelList && obj.labelList.length > 0) {
      obj.labelList.map((i) => {
        arr.push({label: i});
      })
    }
    editDraftQuotation({...obj, labelList: arr,}).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'myDraft', update: res.data});
        if (objc.route) {
          objc.route.go(-1);
        }
      }
    })
  },
  editRowQuotation({commit, dispatch}, objc) {
    editRowQuotation(objc.params).then((res) => {
      if (res.code === 0) {
        commit('dynamicHome/updateState', {state: 'editVisible', update: false}, {root: true});
        dispatch('dynamicHome/getQuotationDetails', objc.id, {root: true});
      }
    })
  },
  //删除报价单
  deleteQuotation({commit, dispatch}, objc) {
    deleteQuotation(objc.id).then((res) => {
      if (res.code === 0) {
        if (objc.path === '/my_dynamic') {
          dispatch('getMyQuotation')
        }
        if (objc.path === '/my_draft') {
          dispatch('getMyDraft')
        }
      }
    })
  },
  //收藏报价单
  collectQuotation({commit, dispatch}, objc) {
    collectQuotation(objc.id).then((res) => {
      if (res.code === 0) {
        if (objc.path === '/dynamic_recommend') {
          dispatch('dynamicHome/getQuotationRecommend', null, {root: true});
        }
        if (objc.path === '/dynamic_subscribe') {
          dispatch('dynamicHome/getQuotationSubscribe', null, {root: true});
        }

        //我的=>动态
        if (objc.path === '/my_dynamic') {
          dispatch('getMyQuotation')
        }
        //我的=>收藏
        if (objc.path === '/collection') {
          dispatch('getMyCollect')
        }
        //我的=>草稿
        if (objc.path === '/my_draft') {
          dispatch('getMyDraft')
        }

        //刷新详情
        if (objc.path === 'details') {
          dispatch('dynamicHome/getQuotationDetails', objc.id, {root: true});
        }
      }
    })
  },
  //取消收藏报价单
  cancelCollectQuotation({commit, dispatch}, objc) {
    cancelCollectQuotation(objc.id).then((res) => {
      if (res.code === 0) {
        //首页=>推荐
        if (objc.path === '/dynamic_recommend') {
          dispatch('dynamicHome/getQuotationRecommend', null, {root: true});
        }
        //首页=>订阅
        if (objc.path === '/dynamic_subscribe') {
          dispatch('dynamicHome/getQuotationSubscribe', null, {root: true});
        }

        //我的=>动态
        if (objc.path === '/my_dynamic') {
          dispatch('getMyQuotation')
        }
        //我的=>收藏
        if (objc.path === '/collection') {
          dispatch('getMyCollect')
        }
        //我的=>草稿
        if (objc.path === '/my_draft') {
          dispatch('getMyDraft')
        }

        //刷新详情
        if (objc.path === 'details') {
          dispatch('dynamicHome/getQuotationDetails', objc.id, {root: true});
        }
      }
    })
  },

  //获取个人信息
  getUserDetails({commit, dispatch}, objc) {
    getUserDetails(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'userData', update: res.data})
      }
    })
  },
  //修改个人信息
  updateUser({commit, dispatch}, objc) {
    updateUser(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getUserDetails', objc.userId);
        commit('common/updateState', {state: 'fileUrl', update: null}, {root: true})
        dispatch('login/getUserInfo', null, {root: true});
      }
    })
  },
  //解除绑定微信
  unbindWx({commit, dispatch}, objc) {
    unbindWx(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getUserDetails', objc);
      }
    })
  },

  getBoundCode({commit, dispatch}, objc) {
    getBoundCode().then((res) => {
      commit('updateState', {state: 'wx_code', update: res.data});
      commit('updateState', {state: 'codeState', update: {status: '0'}});
    })
  },
  getBoundStatus({commit, dispatch}, objc) {
    getBoundStatus(objc).then((res) => {
      if (res.code == 0) {
        commit('updateState', {state: 'codeState', update: res.data});
        const {guid, status} = res.data;
        if (status == 0) {
          //todo 二维码正常可以扫
        }
        if (status && status != 0) {
          // 第一个是accessToken   第二个是refreshToken
          let arr = status.split(',');
          let params = {
            access_token: arr[0],
            refresh_token: arr[1],
            grant_type: 'refresh_token'
          };
          dispatch('reLogin', {params});
        }
      } else {
        //二维码失效
        commit('updateState', {state: 'codeState', update: {status: '1'}});
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'childMenu') {
      vue.ls.set(payload.state, payload.update);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/dynamic/modules/dynamicMy.js